import { Loader } from './Loader';

export const endTransportingConditionsLoader: { (token?: string): Loader } = (token) =>
  new Loader(token);
